import { DeleteIcon } from '@approvalmax/ui/src/old/icons';
import { FC, memo } from 'react';

import { DeleteButton, FilePaperClipIcon, Name, Root } from './ImportFilePreview.styles';
import { ImportFilePreviewProps } from './ImportFilePreview.types';

const ImportFilePreview: FC<ImportFilePreviewProps> = memo((props) => {
    const { fileName, disabled, onRemove } = props;

    return (
        <Root>
            <FilePaperClipIcon width={16} height={15} />

            <Name>{fileName}</Name>

            {!disabled && (
                <DeleteButton execute={onRemove}>
                    <DeleteIcon width={10} height={10} />
                </DeleteButton>
            )}
        </Root>
    );
});

export default ImportFilePreview;
